import React from "react";
import { CardContainer, ContentCard } from "./styles";

type CardProps = {
    bg?: string;
    icon?: string;
    title?: string;
    changeSize?: boolean;
};

const CardCarousel = ({ bg, icon, title, changeSize }: CardProps) => {
    return (
        <CardContainer background={bg} changeSize={changeSize}>
            <ContentCard background={bg} changeSize={changeSize}>
                <img src={icon} alt={title} />
                <p>{title}</p>
            </ContentCard>
        </CardContainer>
    );
};

export default CardCarousel;
